/* === Delivery Ace — Module Data (структура) ===
 *
 * Проза живёт не здесь, а в src/i18n/catalog/content.<lang>.js и адресуется
 * ключами K('...'). Здесь остаётся только то, что одинаково на всех языках:
 * идентификаторы, пути к картинкам, очки, флаги.
 *
 * Этот файл сгенерирован из англоязычной версии данных; дальше он правится
 * руками наравне с остальным кодом. Чтобы добавить сцену — добавь ключи во
 * ВСЕ каталоги, иначе проверка полноты каталогов упадёт.
 */
import { K } from '@/i18n/key';

export const ALISA_IMAGES = {
  hero: '/images/Alisa_neutral.png',
  approval: '/images/Alisa_approval.png',
  serious: '/images/Alisa_serious.png',
  neutral: '/images/Alisa_neutral.png',
  disappointed: '/images/Alisa_serious.png',
  excited: '/images/Alisa_approval.png',
  icon: '/images/Alisa_icon.png',
};

export const SCENE_IMAGES = {
  morning_check: '/images/Background.png',
  documents: '/images/Background.png',
  app_activation: '/images/Background.png',
  delivery_zones: '/images/Background.png',
  equipment: '/images/Background.png',
};

export const MODULES = [
  {
    id: 'module_1',
    title: K('modules.module_1.title'),
    thumbnail: '/images/module_1.png',
    description: K('modules.module_1.description'),
    duration_minutes: 5,
    is_locked: false,
    scenes: ['s1_welcome', 's2_documents', 's3a_technical_check', 's3b_equipment', 's4_app_activation', 's5_delivery_zones', 's6_summary'],
  },
  {
    id: 'module_2',
    title: K('modules.module_2.title'),
    thumbnail: '/images/module_2.png',
    description: K('modules.module_2.description'),
    duration_minutes: 7,
    is_locked: true,
    scenes: [],
  },
  {
    id: 'module_3',
    title: K('modules.module_3.title'),
    thumbnail: '/images/module_3.png',
    description: K('modules.module_3.description'),
    duration_minutes: 6,
    is_locked: true,
    scenes: [],
  },
  {
    id: 'module_4',
    title: K('modules.module_4.title'),
    thumbnail: '/images/module_4.png',
    description: K('modules.module_4.description'),
    duration_minutes: 7,
    is_locked: true,
    scenes: [],
  },
  {
    id: 'module_5',
    title: K('modules.module_5.title'),
    thumbnail: '/images/module_5.png',
    description: K('modules.module_5.description'),
    duration_minutes: 5,
    is_locked: true,
    scenes: [],
  },
  {
    id: 'module_6',
    title: K('modules.module_6.title'),
    thumbnail: '/images/module_6.png',
    description: K('modules.module_6.description'),
    duration_minutes: 4,
    is_locked: true,
    scenes: [],
  },
];

export const SCENES = {
  s1_welcome: {
    id: 's1_welcome',
    type: 'info',
    title: K('scenes.s1_welcome.title'),
    image: SCENE_IMAGES.morning_check,
    alisa_emotion: 'excited',
    alisa_text: K('scenes.s1_welcome.alisa_text'),
  },
  s2_documents: {
    id: 's2_documents',
    type: 'choice',
    title: K('scenes.s2_documents.title'),
    image: SCENE_IMAGES.documents,
    alisa_emotion: 'neutral',
    alisa_text: K('scenes.s2_documents.alisa_text'),
    choices: [
      {
        id: 'c1',
        text: K('scenes.s2_documents.choices.c1.text'),
        is_optimal: true,
        feedback: K('scenes.s2_documents.choices.c1.feedback'),
        alisa_emotion: 'approval',
        scores: { Safety: 10, Professionalism: 10 },
      },
      {
        id: 'c2',
        text: K('scenes.s2_documents.choices.c2.text'),
        is_optimal: false,
        feedback: K('scenes.s2_documents.choices.c2.feedback'),
        alisa_emotion: 'disappointed',
        scores: { Safety: 3, Professionalism: 2 },
      },
      {
        id: 'c3',
        text: K('scenes.s2_documents.choices.c3.text'),
        is_optimal: false,
        feedback: K('scenes.s2_documents.choices.c3.feedback'),
        alisa_emotion: 'serious',
        scores: { Safety: 4, Professionalism: 3 },
      },
    ],
  },
  s3a_technical_check: {
    id: 's3a_technical_check',
    type: 'choice',
    title: K('scenes.s3a_technical_check.title'),
    image: SCENE_IMAGES.morning_check,
    alisa_emotion: 'neutral',
    alisa_text: K('scenes.s3a_technical_check.alisa_text'),
    choices: [
      {
        id: 'choice_1',
        text: K('scenes.s3a_technical_check.choices.choice_1.text'),
        scores: {
          Safety: 20,
          Efficiency: 10,
          Professionalism: 15
        },
        feedback: K('scenes.s3a_technical_check.choices.choice_1.feedback'),
        is_optimal: true,
        alisa_emotion: 'approval'
      },
      {
        id: 'choice_2',
        text: K('scenes.s3a_technical_check.choices.choice_2.text'),
        scores: {
          Safety: -15,
          Professionalism: -10
        },
        feedback: K('scenes.s3a_technical_check.choices.choice_2.feedback'),
        is_optimal: false,
        alisa_emotion: 'disappointed'
      },
      {
        id: 'choice_3',
        text: K('scenes.s3a_technical_check.choices.choice_3.text'),
        scores: {
          Safety: -25,
          Professionalism: -20
        },
        feedback: K('scenes.s3a_technical_check.choices.choice_3.feedback'),
        is_optimal: false,
        alisa_emotion: 'serious'
      }
    ],
  },
  s3b_equipment: {
    id: 's3b_equipment',
    type: 'choice',
    title: K('scenes.s3b_equipment.title'),
    image: SCENE_IMAGES.equipment,
    alisa_emotion: 'neutral',
    alisa_text: K('scenes.s3b_equipment.alisa_text'),
    choices: [
      {
        id: 'c1',
        text: K('scenes.s3b_equipment.choices.c1.text'),
        is_optimal: true,
        feedback: K('scenes.s3b_equipment.choices.c1.feedback'),
        alisa_emotion: 'approval',
        scores: { Efficiency: 10, Professionalism: 10 },
      },
      {
        id: 'c2',
        text: K('scenes.s3b_equipment.choices.c2.text'),
        is_optimal: false,
        feedback: K('scenes.s3b_equipment.choices.c2.feedback'),
        alisa_emotion: 'disappointed',
        scores: { Efficiency: 3, Professionalism: 2 },
      },
      {
        id: 'c3',
        text: K('scenes.s3b_equipment.choices.c3.text'),
        is_optimal: false,
        feedback: K('scenes.s3b_equipment.choices.c3.feedback'),
        alisa_emotion: 'serious',
        scores: { Efficiency: 6, Professionalism: 5 },
      },
    ],
  },
  s4_app_activation: {
    id: 's4_app_activation',
    type: 'choice',
    title: K('scenes.s4_app_activation.title'),
    image: SCENE_IMAGES.app_activation,
    alisa_emotion: 'neutral',
    alisa_text: K('scenes.s4_app_activation.alisa_text'),
    choices: [
      {
        id: 'c1',
        text: K('scenes.s4_app_activation.choices.c1.text'),
        is_optimal: true,
        feedback: K('scenes.s4_app_activation.choices.c1.feedback'),
        alisa_emotion: 'approval',
        scores: { Efficiency: 10, Service: 10 },
      },
      {
        id: 'c2',
        text: K('scenes.s4_app_activation.choices.c2.text'),
        is_optimal: false,
        feedback: K('scenes.s4_app_activation.choices.c2.feedback'),
        alisa_emotion: 'disappointed',
        scores: { Efficiency: 2, Service: 3 },
      },
      {
        id: 'c3',
        text: K('scenes.s4_app_activation.choices.c3.text'),
        is_optimal: false,
        feedback: K('scenes.s4_app_activation.choices.c3.feedback'),
        alisa_emotion: 'serious',
        scores: { Efficiency: 5, Service: 4 },
      },
    ],
  },
  s5_delivery_zones: {
    id: 's5_delivery_zones',
    type: 'choice',
    title: K('scenes.s5_delivery_zones.title'),
    image: SCENE_IMAGES.delivery_zones,
    alisa_emotion: 'neutral',
    alisa_text: K('scenes.s5_delivery_zones.alisa_text'),
    choices: [
      {
        id: 'c1',
        text: K('scenes.s5_delivery_zones.choices.c1.text'),
        is_optimal: true,
        feedback: K('scenes.s5_delivery_zones.choices.c1.feedback'),
        alisa_emotion: 'approval',
        scores: { Efficiency: 10, Service: 8 },
      },
      {
        id: 'c2',
        text: K('scenes.s5_delivery_zones.choices.c2.text'),
        is_optimal: false,
        feedback: K('scenes.s5_delivery_zones.choices.c2.feedback'),
        alisa_emotion: 'disappointed',
        scores: { Efficiency: 3, Service: 4 },
      },
      {
        id: 'c3',
        text: K('scenes.s5_delivery_zones.choices.c3.text'),
        is_optimal: false,
        feedback: K('scenes.s5_delivery_zones.choices.c3.feedback'),
        alisa_emotion: 'serious',
        scores: { Efficiency: 6, Service: 5 },
      },
    ],
  },
  s6_summary: {
    id: 's6_summary',
    type: 'info',
    title: K('scenes.s6_summary.title'),
    image: SCENE_IMAGES.morning_check,
    alisa_emotion: 'excited',
    alisa_text: K('scenes.s6_summary.alisa_text'),
    is_final: true,
  },
};

export const getModule = (moduleId) => MODULES.find(m => m.id === moduleId);
export const getScene = (sceneId) => SCENES[sceneId];
export const getModuleScenes = (moduleId) => {
  const module = getModule(moduleId);
  if (!module) return [];
  return module.scenes.map(sid => SCENES[sid]).filter(Boolean);
};
